import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Stack,
  Typography,
} from "@mui/material";

export default function OutreachContactHistory({ api, contact, onClose }) {
  const [page, setPage] = useState({
    events: [],
    hasNextPage: false,
    nextOffset: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    api
      .getOutreachContactHistory(contact.id, 0)
      .then((result) => {
        if (active) setPage(result);
      })
      .catch((failure) => {
        if (active) setError(failure.message);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [api, contact.id]);
  const more = async () => {
    setLoading(true);
    setError("");
    try {
      const next = await api.getOutreachContactHistory(
        contact.id,
        page.nextOffset,
      );
      setPage((current) => ({
        ...next,
        events: [...current.events, ...next.events],
      }));
    } catch (failure) {
      setError(failure.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Dialog open fullWidth maxWidth="md" onClose={onClose}>
      <DialogTitle>
        Outreach history — {contact.firstName} {contact.lastName}
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography>{contact.email}</Typography>
          {contact.convertedAt && (
            <Typography>
              Converted {new Date(contact.convertedAt).toLocaleString()} ·{" "}
              {contact.conversionReason?.replaceAll("_", " ")} ·{" "}
              {contact.convertedUser
                ? `${contact.convertedUser.firstName} ${contact.convertedUser.lastName} (${contact.convertedUser.email})`
                : "Account deleted"}
            </Typography>
          )}
          {error && <Alert severity="error">{error}</Alert>}
          {page.events.map((event) => (
            <Paper key={event.id} variant="outlined" sx={{ p: 1.5 }}>
              <Typography fontWeight={700}>
                {event.kind}: {event.label.replaceAll("_", " ")}
              </Typography>
              <Typography variant="body2">
                {new Date(event.at).toLocaleString()} ·{" "}
                {event.detail?.replaceAll("_", " ")}
              </Typography>
            </Paper>
          ))}
          {!loading && !error && !page.events.length && (
            <Typography>No outreach history yet.</Typography>
          )}
          {loading && <CircularProgress size={24} />}
          {page.hasNextPage && (
            <Button onClick={more} disabled={loading}>
              Load more history
            </Button>
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
